


import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function organisationListUpdateRequiredReducer(state = initialState.organisationListUpdateRequired, action) {
    switch (action.type) {
        case types.LOAD_ORGANISATIONS_SUCCESS:
        case types.LOAD_ORGANISATIONS_UPDATE_SUCCESS:
            return false;
        case types.UPDATED_ORGANISATION_INCOMING:
           case types.UPDATED_ORGANISATION_SUCCESS:
            return true;
        default:
            return state;
    }
}

